import React from "react";
import { Link } from "react-router-dom";
export default function Logohero() {
  return <section data-section-id="262511" id="logohero" className="bg-background text-foreground min-h-screen px-6 md:px-12 flex items-center justify-center text-center relative overflow-hidden bg-cover bg-center !bg-[url(https://guiding-lionfish.10web.cloud/wp-content/uploads/2026/05/Home-Page-Cover-image.png)]">
      {}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-accent/20 rounded-lg blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-secondary/20 rounded-lg blur-[120px] pointer-events-none" />
      
      <div className="max-w-4xl mx-auto flex flex-col items-center gap-6 relative z-10">
        <Link to="/" className="mb-4 transition-transform hover:scale-105">
        </Link>
      </div>
    </section>;
}